
import React from 'react';
import { Calendar } from "lucide-react";

const EmptyDateState: React.FC = () => {
  return (
    <div className="text-center text-muted-foreground">
      <Calendar className="h-12 w-12 mx-auto mb-4 opacity-50" />
      <p>Selecione uma data no calendário para ver os detalhes</p>
    </div>
  );
};

export default EmptyDateState;
